import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FiPlusCircle } from "react-icons/fi";

import { addCategory as addCategoryAction } from "../../../Store/Modules/Menu/Actions";
import { Container, Form } from "./style";
import TextField from "@material-ui/core/TextField";
import Popover from "@material-ui/core/Popover";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";

export default function AddNewCategory(props) {
  const dispatch = useDispatch();
  const categories = useSelector((state) => {
    return state.store.menu;
  });

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [openPopover, setOpenPopover] = React.useState(false);

  const handleAddCategory = (ev) => {
    ev.preventDefault();
    dispatch(addCategoryAction(ev.target.nameShow.value));
    setOpenPopover(false);
  };

  const handleClickAddCategory = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenPopover(true);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
    setOpenPopover(false);
  };

  return (
    <Container {...props}>
      <div onClick={handleClickAddCategory}>
        <FiPlusCircle
          color="#28a7457d"
          style={{ fontSize: "80px", color: "#28a7457d" }}
        />
        <p>Adicione sua primeira Categoria de Produtos</p>
      </div>
      <Popover
        open={openPopover}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <DialogContent>
          <Form onSubmit={handleAddCategory}>
            <TextField
              label="Nome da categoria"
              name="nameShow"
              required
              autoFocus
              variant="outlined"
              size="small"
              autoComplete="off"
            />

            <Button type="submit" variant="contained" color="primary">
              Salvar
            </Button>
          </Form>
          <Button
            onClick={handleClosePopover}
            color="default"
            style={{ float: "right" }}
          >
            Fechar
          </Button>
        </DialogContent>
      </Popover>
    </Container>
  );
}
